var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ico-wrap"},[_c('img',{staticClass:"ico",attrs:{"src":_vm.ico,"alt":"pay-ico"}})])}
var staticRenderFns = []

export { render, staticRenderFns }